<template>
  <div class="shoppingSafety shoppingGuide" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <!--right-->
      <div class="rightTable">
        <el-row class="tac">
          <el-col :span="20">
            <el-menu
              unique-opened="true"
              default-active="2"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose">
              <el-submenu v-for="(item, index) in titleList" :key="item.id" :index="item.id" >
                <template slot="title">
                  <span>{{item.name}}</span>
                </template>
                <div  v-for="list in listDetails" :key="list.id"  @click="goList(list)">
                  <el-menu-item-group >
                    <el-menu-item :index="list.id">{{list.title}}</el-menu-item>
                  </el-menu-item-group>
                </div>
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
      </div>

      <!--left-->
      <div class="left">
        <div>
          <h4>{{arDetail.title}}</h4>
          <div class="ar" v-html="arDetail.content"></div>
        </div>
        <!--<div class="tiaozhuan">-->
          <!--<a>上壹篇：<span>支付安全</span></a>-->
          <!--<a>下壹篇：<span>支付安全</span></a>-->
        <!--</div>-->
      </div>
    </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
  </div>
</template>

<script>
  //common.js
  import {ifSignIn} from '@/utils/common';
  import NavB from '@/pages/detailsPage/NavB'
  import RightTable from '@/pages/shoppingGuide/RightTable'
  //api
  import {articleCats , articlesList ,articlesListDetails } from '@/api/article';

  export default {
    name: 'ShoppingSafety',
    components:{
      NavB,
    },
    data () {
      return {
        titleChild:[{name:'首頁',src:'HomePage'},{name:'支付安全',src:'ShoppingSafety'}],
        activeName: '1',
        /*二级导航id*/
        articleId:this.$route.query.id ,//id
        indexT:0,
        //二级导航下列表id
        articleListId:this.$route.query.ar_id ,//id
        indexS:0,
        //二级导航
        titleList:[1,2,3,4,5],
        //详情
        listDetails:[],
        arDetail:{}
      }
    },
    methods:{
      /*获取二级导航*/
      getTitleList(){
        articleCats({parent_id:3}).then(res =>{
          this.titleList = res.data.data;
        });
      },

      handleOpen(key) {
        this.$router.push({
          name:'ShoppingSafety',
          query:{
            id:key
          }
        });
        this.getArticleList()

      },
      handleClose(key) {
        this.$router.push({
          name:'ShoppingSafety',
          query:{
            id:key
          }
        });
        this.getArticleList()
      },

      /*进入详情页*/
      goList(list){
          this.arDetail = list;
      },

      /*获取列表*/
      getArticleList(){
      /*    var obj = {
            include:'articlecat',
            article:this.articleId
          };*/
        this.listDetails = [];
          articlesList({article_cat_id:this.articleId}).then(res =>{
            this.listDetails = res.data.data;
          })
      }

    },
    created(){
      //二级导航
      this.getTitleList();
      window.scrollTo(0,0)



    },
    watch : {
      '$route':{
        deep: true,
        handler: function(to, from){
          if(to.path == "/shoppingSafety"){
            this.articleId = this.$route.query.id ;
            //文章列表
            this.getArticleList();
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "../../css/shoppingGuide.less";
</style>



// WEBPACK FOOTER //
// src/pages/shoppingGuide/ShoppingSafety.vue